//import cookiebanner from './lib/cookieconsent.min';
import owlCarousel from './lib/owl.carousel.min';

/**
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
!function (e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
}(function (m) {
    var i = /\+/g;

    function x(e) {
        return v.raw ? e : encodeURIComponent(e)
    }

    function g(e, n) {
        var o = v.raw ? e : function (e) {
            0 === e.indexOf('"') && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
            try {
                return e = decodeURIComponent(e.replace(i, " ")), v.json ? JSON.parse(e) : e
            } catch (e) {
            }
        }(e);
        return m.isFunction(n) ? n(o) : o
    }

    var v = m.cookie = function (e, n, o) {
        if (1 < arguments.length && !m.isFunction(n)) {
            if ("number" == typeof (o = m.extend({}, v.defaults, o)).expires) {
                var i = o.expires, r = o.expires = new Date;
                r.setMilliseconds(r.getMilliseconds() + 864e5 * i)
            }
            return document.cookie = [x(e), "=", (t = n, x(v.json ? JSON.stringify(t) : String(t))), o.expires ? "; expires=" + o.expires.toUTCString() : "", o.path ? "; path=" + o.path : "", o.domain ? "; domain=" + o.domain : "", o.secure ? "; secure" : ""].join("")
        }
        for (var t, c, u = e ? void 0 : {}, s = document.cookie ? document.cookie.split("; ") : [], a = 0, d = s.length; a < d; a++) {
            var p = s[a].split("="), f = (c = p.shift(), v.raw ? c : decodeURIComponent(c)), l = p.join("=");
            if (e === f) {
                u = g(l, n);
                break
            }
            e || void 0 === (l = g(l)) || (u[f] = l)
        }
        return u
    };
    v.defaults = {}, m.removeCookie = function (e, n) {
        return m.cookie(e, "", m.extend({}, n, {expires: -1})), !m.cookie(e)
    }
});


/**
 * Reorder list
 * @param order
 * @returns {$}
 */
$.fn.orderChildren = function (order) {
    // console.log(order);
    // console.log(this);
    this.each(function () {
        var el = $(this), i;
        for (i = order.length - 1; i >= 0; i--) {
            el.prepend(el.children(order[i]));
        }
    });

    return this;
};


String.prototype.replaceArray = function (find, replace) {
    var replaceString = this;
    var regex;
    for (var i = 0; i < find.length; i++) {
        regex = new RegExp(find[i], "g");
        replaceString = replaceString.replace(regex, replace[i]);
    }
    return replaceString;
};


/**
 * Slugerizing functionality
 * @param str
 * @returns {string}
 */
function slugerize(str) {
    var search,
        replace;

    search = [
        'ä',
        'ö',
        'ü',
        'ß',
        ', ',
        ' ',
        '/',
        '&amp;',
        '&',
        '--',
        '---',
    ];

    replace = [
        'ae',
        'oe',
        'ue',
        'ss',
        '-',
        '-',
        '',
        'und',
        'und',
        '-',
        '-',
    ];

    str = str.toLowerCase().replaceArray(search, replace);

    str = str.replace(/[^a-z0-9+"\']/g, '-');

    return str;
}

/**
 * Global logging functionality
 * @param msg
 * @param group
 */
function log(msg, group) {
    switch (group) {
        default:
            if ($.cookie('is_rk') === '1') {
                console.log(msg);
            }
            break;
    }
}


var _window = $(window),
    _document = $(document),
    _html = $('html'),
    _body = $('body'),
    _lang = _html.attr('lang'),
    $apiURL = 'https://api-jobs.hse.com/',
    $pageReady = 1,

    /**
     * Api handler
     * @type {{getResponse: api.getResponse, respond: api.respond}}
     */
    api = {
        // Send POST/GET request
        sendRequest: function (type, endpoint, options, responseType) {
            options.language = 'de'
            if (_lang == 'en-US') {
                options.language = 'en';
            }

            $.ajax({
                url: $apiURL + endpoint,
                type: type,

                async: true,
                data: options,

                error: function (data) {
                    log('** ERROR: ');
                    log(data);
                    log('** **** ****');
                },

                success: function (response) {
                    var target = false;
                    if (options.target !== undefined) {
                        // Add the target
                        target = options.target;
                    }

                    // Trigger the response
                    api.respond(response, responseType, target);
                }
            });
        },

        // Respond to the request
        respond: function (response, responseType, target) {
            responseType = responseType.trim().split(',');

            /*
            Not needed for the moment
            if(response.status !== undefined && response.status === false) {
                console.error('ERROR: API returned an Error.');
                return false;
            }
            */

            var i, task;
            for (i = 0; i <= responseType.length; i++) {
                task = responseType[i];

                // Make sure there is something to handle
                if (task !== undefined && task.length > 0) {
                    // If appending is requested
                    if (task.substr(0, 8) === 'appendTo') {
                        var targetElm = $('#' + task.substr(9));

                        // Check if the elm actually exist
                        if (targetElm[0]) {
                            targetElm.empty().append(response);
                        }

                        // If the function exists => run it
                    } else if (task.substr(-2) === '()') {
                        // Check if function exists
                        switch (task.substr(0, task.length - 2)) {
                            // Function to show the results
                            case 'fn.search.showResults':
                                fn.search.showResults(response);
                                break;

                            // Function to replace the counts in the unit buttons
                            case 'ajaxHandler.initialReplace.replaceUnitButtons':
                                ajaxHandler.initialReplace.replaceUnitButtons(response, target);
                                break;

                            // Function to replace the counts in the unit title
                            case 'ajaxHandler.initialReplace.replaceUnitCount':
                                ajaxHandler.initialReplace.replaceUnitCount(response, target);
                                break;

                            // Function to replace the counts in the content
                            case 'ajaxHandler.initialReplace.replaceSumCount':
                                ajaxHandler.initialReplace.replaceSumCount(response, target);
                                break;

                            // Function to get all available jobs
                            case 'ajaxHandler.initialReplace.getAllJobs':
                                ajaxHandler.initialReplace.getAllJobs(response, target);
                                break;

                            // Function to show the the job alarm response
                            case 'fn.jobAlarm.showResponse':
                                fn.jobAlarm.showResponse(response, target);
                                break;

                            // Function to show the the job alarm response
                            case 'ajaxHandler.initialReplace.job_count':
                                ajaxHandler.initialReplace.job_count(response, target);
                                break;
                        }
                    }
                }
            }
        },
    },


    /**
     * Ajax handler
     * @type {{initTargets: null, clickTargets: null, initialReplace: {replaceUnitButtons: ajaxHandler.initialReplace.replaceUnitButtons, replaceSumCount: ajaxHandler.initialReplace.replaceSumCount, getAllJobs: ajaxHandler.initialReplace.getAllJobs, init: ajaxHandler.initialReplace.init}, clickTargetsListener: {init: ajaxHandler.clickTargetsListener.init}, init: ajaxHandler.init}}
     */
    ajaxHandler = {
        initTargets: null,
        clickTargets: null,

        // For ajax elements which trigger on init
        initialReplace: {
            replaceUnitButtons: function (response, target) {
                // Create the target elm
                if (target !== '') {
                    target = $('#' + target);
                }

                // Check if there is a count
                if (response.count !== undefined && target[0]) {
                    var count = parseInt(response.count);

                    // Replace the target elm content
                    if (_lang == 'en-US') {
                        target.html('<p class="h5">' + count + (count > 1 ? ' Jobs' : ' Job') + '</p><strong>' + ' waiting for you</strong>');
                    } else {
                        target.html('<p class="h5">' + count + (count > 1 ? ' Jobs' : ' Job') + '</p><strong>' + (count > 1 ? ' warten' : ' wartet') + ' auf Dich</strong>');
                    }

                }
            },

            replaceUnitCount: function (response, target) {
                // Create the target elm
                if (target !== '') {
                    target = $('#' + target);
                }

                // Check if there is a count
                if (response.count !== undefined && target[0]) {
                    var count = parseInt(response.count);

                    if (count === 1) {
                        if (_lang == 'en-US') {
                            target.parent().html('Directly to our job offer');
                        } else {
                            target.parent().html('Direkt zu unserem Jobangebot');
                        }
                    } else {
                        // Replace the target elm content
                        target.html(count);
                    }
                }
            },

            replaceSumCount: function (response, target) {
                // Create the target elm
                if (target !== '') {
                    target = $('#' + target);
                }

                // Check if there is a count
                if (response.count !== undefined && target[0]) {
                    var count = parseInt(response.count);
                    // console.log(count);

                    // Replace the target elm content
                    if (target.parent().hasClass('jobs-overview__content__title-count')) {

                        if (_lang == 'en-US') {
                            if (count > 1) {
                                target.replaceWith('We found <span class="count">' + count + '</span> jobs for you.');
                            }else if (count < 1) {
                                target.replaceWith('');
                            }  else {
                                target.replaceWith('We found <span class="count">a</span> job for you.');
                            }
                        } else {
                            count = count - 1;
                            if (count > 1) {
                                target.replaceWith('Wir haben <span class="count">' + count + '</span> Jobs für Dich gefunden.');
                            } else if (count < 1) {
                                target.replaceWith('');
                            } else {
                                target.replaceWith('Wir haben <span class="count">einen</span> Job für Dich gefunden.');
                            }
                        }

                    } else {
                        target.replaceWith(count);
                    }
                }
            },

            getAllJobs: function (response, target) {
                // Wait until the page is ready

                // Create the target elm
                if (target !== '') {
                    target = $('#' + target);
                }

                // Check if there is a count
                if ((response.results !== undefined && target[0])) {
                    var i, appendData = '';

                    var url = '#',
                        elm,
                        locations = '-',
                        filter_classes = '',
                        is_remembered,
                        x,
                        units,
                        grades,
                        savedJobs = $.cookie('hse24SavedJobs');

                    if (savedJobs !== undefined && savedJobs.length > 0) {
                        savedJobs = savedJobs.split(',');
                    }

                    for (i = 0; i < response.results.length; i++) {
                        elm = response.results[i];
                        url = elm.job_link;

                        if (elm.locations.length > 0) {
                            locations = elm.locations[0].municipality;
                        }

                        is_remembered = false;
                        if ($.inArray(elm.job_id.toString(), savedJobs) != -1) {
                            is_remembered = true;
                        }

                        filter_classes = '';
                        // filter_classes = 'hse-location-ismaning-bei-muenchen hse-unit- hse-level-fuehrungsposition odd';

                        // Get the locations of the job
                        for (x = 0; x < elm.locations.length; x++) {
                            filter_classes += ' ' + slugerize('hse-location-' + elm.locations[x].municipality);
                        }

                        // Get the units
                        for (x = 0; x < elm.categories.length; x++) {
                            // console.log(elm.categories[x].title);
                            filter_classes += ' ' + slugerize('hse-unit-' + elm.categories[x].title);
                        }

                        // Get the grades
                        grades = elm.jobgrade.split(',');
                        for (x = 0; x < grades.length; x++) {
                            filter_classes += ' ' + slugerize('hse-level-' + grades[x]);
                        }

                        if (_body.hasClass('lang-en')) {
                            elm.job_link = elm.job_link + '?lang=en';
                        }

                        appendData += '<li data-job-id="' + elm.job_id + '" class="list-item ' + filter_classes + '"> <p class="title"> <a class="job-list__link" href="' + elm.job_link + '">' + elm.title + '</a> </p> <p class="location"> <a class="job-list__link" href="' + elm.job_link + '">' + locations + '</a> </p> <p class="level"> <a class="job-list__link" href="' + elm.job_link + '">' + elm.jobgrade.replace(/,/g, ', ') + '</a> </p> <p class="remember"> <a href="#" class="remember-link ' + ((is_remembered) ? 'remember-link--remembered' : '') + ' job-list__legend__name" data-job-id="' + elm.job_id + '"> <i class="fa fa-heart-o"></i> </a> </p> </li>';
                    }

                    // Replace the target elm content
                    target.append(appendData);

                    $pageReady = 1;

                    _window.trigger('jobsLoaded');

                    // Make sure odd/even bg-colors are matching
                    fn.jobsOverview.filter.handleOddEven();

                    // Remove "load-more" button
                    $('.load-more-link').remove();

                    // Restart listeners
                    fn.remember.listener();
                }
            },

            job_count: function (response, target) {
                if (target !== '') {
                    target = $('#' + target);
                }

                // Check if there is a count
                if (response.count !== undefined && target[0]) {
                    var count = parseInt(response.count);

                    target.after(count).remove();
                }
            },

            init: function () {
                var _this;
                ajaxHandler.initTargets.each(function () {
                    _this = $(this);

                    // Make sure the element has a id
                    if (_this.attr('id') === '' || _this.attr('id') === undefined) {
                        _this.attr('id', 'ajax-response-' + Math.floor(Math.random(0, 10) * 100))
                    }

                    // Check what's to do
                    switch (_this.attr('data-ajax-load')) {
                        // Load the unit count
                        case 'unit_count':
                            api.sendRequest('GET', 'count', {
                                unit: _this.attr('data-unit-id'),
                                target: _this.attr('id')
                            }, 'ajaxHandler.initialReplace.replaceUnitButtons()');
                            break;

                        // Load the unit count
                        case 'single_unit_count':
                            api.sendRequest('GET', 'count', {
                                unit: _this.attr('data-unit-id'),
                                target: _this.attr('id')
                            }, 'ajaxHandler.initialReplace.replaceUnitCount()');
                            break;

                        // Load the sum count
                        case 'sum_count':
                            api.sendRequest('GET', 'count', {target: _this.attr('id')}, 'ajaxHandler.initialReplace.replaceSumCount()');
                            break;

                        // Load the sum count
                        case 'job_count':
                            var params = null;

                            if (_this.data('jobgrade').length > 0) {
                                params = {
                                    job_grade: _this.data('jobgrade'),
                                    target: _this.attr('id')
                                };
                            } else if (_this.data('unit').length > 0) {
                                params = {
                                    unit: _this.data('unit'),
                                    target: _this.attr('id')
                                };
                            }

                            if (params !== null) {
                                api.sendRequest('GET', 'count', params, 'ajaxHandler.initialReplace.job_count()');
                            }
                            break;

                        // Load all jobs
                        case 'all_jobs':
                            // Make sure the site isnt ready
                            $pageReady = 0;

                            api.sendRequest('GET', 'search', {
                                limit: 999,
                                offset: _this.data('offset'),
                                target: _this.attr('id')
                            }, 'ajaxHandler.initialReplace.getAllJobs()');
                            break;
                    }
                })
            }
        },

        // For ajax elements which trigger on click
        clickTargetsListener: {
            init: function () {
                var _this;
                ajaxHandler.clickTargets.on('click', function (e) {
                    e.preventDefault();
                    _this = $(this);

                    switch (_this.attr('data-ajax-load')) {
                    }
                });
            }
        },

        init: function () {
            // Set all target elements
            this.initTargets = $('[data-ajax-action="init"]');
            this.clickTargets = $('[data-ajax-action="click"]');

            // If there are more than 0 elements => start
            if (this.initTargets.length > 0) {
                this.initialReplace.init();
            }

            // If there are more than 0 elements => start
            if (this.clickTargets.length > 0) {
                this.clickTargetsListener.init();
            }
        }
    },


    /**
     * Plugins and inits
     * @type {{deviceProfile: {supportsFlexbox: boolean, screenWidth: number, screenHeight: number, baseFontSize: number, mobileLayoutThreshold: number, mobileLayout: boolean, orientation: string, orientationChanged: boolean, init: plugins.deviceProfile.init, resize: plugins.deviceProfile.resize}, owlCarousel: plugins.owlCarousel, init: plugins.init, loaded: plugins.loaded}}
     */
    plugins = {
        deviceProfile: {
            supportsFlexbox: true,
            screenWidth: 0,
            screenHeight: 0,
            baseFontSize: 0,
            mobileLayoutThreshold: 1023,
            mobileLayout: false,
            orientation: 'landscape',
            orientationChanged: false,

            init: function () {
                this.supportsFlexbox = _html.hasClass('flexbox');
                this.screenWidth = _window.width();
                this.screenHeight = _window.height();
                this.baseFontSize = parseInt(_html.css("fontSize"));
                this.mobileLayout = (this.screenWidth <= this.mobileLayoutThreshold) ? true : false;

                _html.addClass("orientation-" + this.orientation);

                if (this.screenWidth < this.screenHeight) {

                    _html.removeClass("orientation-" + this.orientation);

                    this.orientation = 'portrait';
                    this.orientationChanged = true;

                    _html.addClass("orientation-" + this.orientation);
                }
            },

            resize: function () {
                this.screenWidth = _window.width();
                this.screenHeight = _window.height();
                this.baseFontSize = parseInt(_html.css("fontSize"));
                this.mobileLayout = (this.screenWidth <= this.mobileLayoutThreshold) ? true : false;

                var newOrientation = (this.screenWidth < this.screenHeight) ? 'portrait' : 'landscape';

                if (newOrientation != this.orientation) {
                    this.orientationChanged = true;
                    _html.removeClass("orientation-" + this.orientation);
                } else {
                    this.orientationChanged = false;
                }

                this.orientation = newOrientation;

                _html.addClass("orientation-" + this.orientation);
            }
        },

        owlCarousel: function () {
            $('.teasers__wrap.owl-carousel').owlCarousel({
                items: 2,
                loop: true,
                dots: true,
                nav: true,
                touchDrag: true,
                draggable: false,
                mouseDrag: false,
                dragCursor: false,
                responsive: {
                    0: {
                        items: 1
                    },
                    1200: {
                        items: 2
                    }
                }
            });

            $('.unit__slider.owl-carousel').owlCarousel({
                items: 1,
                loop: true,
                dots: true,
                touchDrag: true,
                draggable: false,
                mouseDrag: false,
                dragCursor: false
            });
        },

        init: function () {
            plugins.owlCarousel();
            $('body').on('click', '.teaser-link', function (e) {
                location.href = $(this).data('href');
            });

            $('body').on('click', ".benefit-link", function (e) {
                location.href = $(this).data('href');
            });

            $('body').on('click', "a[href='#anfrage']", function (e) {
                e.preventDefault();
                $('body').toggleClass('layer-open');
                $('#anfrage').toggleClass('active');
                if ($('#anfrage').hasClass('active')) {
                    fn.header.nav.addClass('main-header__nav--visible');
                } else {
                    fn.header.nav.removeClass('main-header__nav--visible');
                }
            });
        },

        loaded: function () {

        }
    },


    /**
     * Main functionality
     * @type {{form: {labels: {labelElms: null, inputElms: null, checkElement: fn.form.labels.checkElement, init: fn.form.labels.init}, init: fn.form.init}, search: {resultsElm: null, inputElm: null, overlayElm: null, loader: {showLoader: fn.search.loader.showLoader, hideLoader: fn.search.loader.hideLoader}, overlay: {showOverlay: fn.search.overlay.showOverlay, hideOverlay: fn.search.overlay.hideOverlay}, clearResults: fn.search.clearResults, showResults: fn.search.showResults, startSearch: fn.search.startSearch, init: fn.search.init}, entry_level: {init: fn.entry_level.init}, remember: {removeJob: fn.remember.removeJob, addJob: fn.remember.addJob, listener: fn.remember.listener, init: fn.remember.init}, jobsOverview: {filter: {jobListOrder: null, startFiltering: fn.jobsOverview.filter.startFiltering, handleJobAlert: fn.jobsOverview.filter.handleJobAlert, handleOddEven: fn.jobsOverview.filter.handleOddEven, handleCount: fn.jobsOverview.filter.handleCount, saveJobListOrder: fn.jobsOverview.filter.saveJobListOrder, resetJobListOrder: fn.jobsOverview.filter.resetJobListOrder, binding: fn.jobsOverview.filter.binding}, hashFilter: {addCheckboxStatus: fn.jobsOverview.hashFilter.addCheckboxStatus, init: fn.jobsOverview.hashFilter.init}, init: fn.jobsOverview.init}, jobAlarm: {submitButton: null, emailInput: null, phoneInput: null, dataPrivacyCheckbox: null, error: string, isFormValid: (function(): boolean), submitForm: fn.jobAlarm.submitForm, binding: fn.jobAlarm.binding, init: fn.jobAlarm.init}, accordion: {init: fn.accordion.init}, header: {nav: null, navHeight: number, agent: fn.header.agent, init: fn.header.init}, jobSingle: {init: fn.jobSingle.init}, init: fn.init, loaded: fn.loaded}}
     */
    fn = {
        /**
         * General form functions
         */
        form: {
            labels: {
                labelElms: null,
                inputElms: null,

                // Check single elements
                checkElement: function (_this) {
                    var targetID = _this.attr('for'),
                        targetInput = $('#' + targetID);

                    // Check if the element exists
                    if (targetInput[0]) {
                        if (targetInput.val().length === 0) {
                            _this.addClass('inactive');
                        } else {
                            _this.removeClass('inactive');
                        }
                    }
                },

                init: function () {
                    // Set vars
                    this.labelElms = $('.form--animated-labels label');
                    this.inputElms = $('.form--animated-labels input, .form--animated-labels textarea, .form--animated-labels select');

                    // Make sure there are available elements
                    if (this.labelElms === null) {
                        log('EXIT: There are no labels found', 'labels');
                        return false;
                    }

                    // Check current state
                    this.labelElms.each(function () {
                        fn.form.labels.checkElement($(this));
                    });

                    // Handle select labels
                    var _this, select;
                    $('.input-wrapper--select label').on('click', function () {
                        _this = $(this);
                        select = _this.next('select');

                        select.focus();
                    });

                    // Focus
                    this.inputElms.on('focus', function () {
                        var _this = $(this),
                            targetLabel = $('label[for="' + _this.attr('id') + '"]');

                        targetLabel.removeClass('inactive');
                    });

                    // Focus out
                    this.inputElms.on('focusout', function () {
                        var _this = $(this),
                            targetLabel = $('label[for="' + _this.attr('id') + '"]');

                        // Only set the label inactive if there is no value
                        if (_this.val().length === 0) {
                            targetLabel.addClass('inactive');
                        }
                    });

                    // On Input
                    this.inputElms.on('change', function () {
                        var _this = $(this),
                            targetLabel = $('label[for="' + _this.attr('id') + '"]');

                        if (_this.val().length > 0) {
                            log("removeClass('inactive')");

                            // There is a value, the label is active
                            targetLabel.removeClass('inactive');
                        } else {
                            log("addClass('inactive')");

                            // There is no value, the label is inactive
                            targetLabel.addClass('inactive');
                        }
                    });
                }
            },

            init: function () {
                // Start the label functionalities
                this.labels.init();
            }
        },


        /**
         * Search functionality
         */
        search: {
            resultsElm: null,
            inputElm: null,
            overlayElm: null,

            loader: {
                showLoader: function () {
                    if (!fn.search.resultsElm.hasClass('job-list--loading')) {
                        log('showLoader', 'search');
                        fn.search.resultsElm.addClass('job-list--loading');
                    }
                },

                hideLoader: function () {
                    if (fn.search.resultsElm.hasClass('job-list--loading')) {
                        log('hideLoader', 'search');
                        fn.search.resultsElm.removeClass('job-list--loading');
                    }
                }
            },

            overlay: {
                showOverlay: function () {
                    fn.search.overlayElm.addClass('active');
                },

                hideOverlay: function () {
                    fn.search.overlayElm.removeClass('active');
                }
            },

            clearResults: function () {
                // Hide the loader
                fn.search.loader.hideLoader();

                // Hide the overlay
                fn.search.overlay.hideOverlay();

                // Empty the search results
                fn.search.resultsElm.empty().addClass('job-list--inactive').removeClass('job-list--active');

                // Clear term and label
                fn.search.inputElm.val('');
                $('.search__info-text').addClass('inactive');

                $('.search-form, .site-header').removeClass('active');

                _body.removeClass('search-active');
            },


            /**
             * Gets called by the ajax call
             * @param data
             */
            showResults: function (data) {
                fn.search.loader.hideLoader();

                if (data !== undefined && data.results !== undefined) {
                    var i,
                        response = '<li class="list-item list-item--legend"> <p class="title">Jobtitel</p> <p class="location">Standort</p> <p class="level">Einstiegslevel</p> </li>',
                        _this;
                    if (_lang === 'en-US') {
                        response = '<li class="list-item list-item--legend"> <p class="title">Job title</p> <p class="location">Location</p> <p class="level">Entry level</p> </li>';
                    }

                    if (data.results.length > 0) {
                        for (i = 0; i < data.results.length; i++) {
                            _this = data.results[i];

                            if (_lang === 'en-US') {
                                _this.job_link += '?lang=en';
                            }

                            response += '<li data-job-id="' + _this.job_id + '" class="' + (i % 2 ? 'even' : 'odd') + '"> <a class="job-list__link" href="' + _this.job_link + '"> <p class="title">' + _this.title + '</p> <p class="location">' + _this.locations[0].municipality + '</p> <p class="level">' + _this.jobgrade.replace(/,/g, ', ') + '</p> </a></li>';
                            // response += '<li> <a href="'+ _this.job_link +'" data-id="'+ _this.job_id +'">'+ _this.title +' - '+ _this.jobgrade +' - '+ _this.locations[0].municipality +'</a> </li>';
                        }

                        // Place the "load-all" button
                        if (data.isLimited !== undefined) {
                            if (_lang === 'en-US') {
                                response += '<li><a href="#" class="button button--load-all">' + data.limitedCount + ' show more jobs</a></li>';
                            } else {
                                response += '<li><a href="#" class="button button--load-all">' + data.limitedCount + ' weitere Jobs anzeigen</a></li>';
                            }
                        }
                    } else {
                        if (_lang === 'en-US') {
                            response += '<li>Unfortunately there is nothing here today.</li>'
                        } else {
                            response += '<li>Heute ist leider nichts dabei.</li>'
                        }

                    }

                    // Update the elm
                    fn.search.resultsElm
                    .empty()
                    .append(response)
                    .addClass('job-list--active');

                    $('.button--load-all').on('click', function (e) {
                        e.preventDefault();

                        $(this).remove();
                        fn.search.loader.showLoader();
                        fn.search.startSearch(fn.search.inputElm);
                    });
                }
            },


            /**
             * If a term input is given
             * @param _this
             * @param limit
             * @param offset
             */
            startSearch: function (_this, limit, offset) {
                log('_this is:', 'search');
                log(_this, 'search');

                var _val = _this.val(), params = {term: _val};

                if (limit !== undefined && offset !== undefined) {
                    params = {term: _val, limit: limit, offset: offset};
                }
                // Load the result
                api.sendRequest('GET', 'search', params, 'fn.search.showResults()');
            },

            headerSearch: {
                open: function () {
                    // fn.search.overlay.showOverlay();
                    $('.main-header__search').addClass('active');
                },

                close: function () {
                    // fn.search.overlay.hideOverlay();
                    $('.main-header__search').removeClass('active');
                }
            },


            /**
             * Binding and initial functionality
             */
            init: function () {
                this.inputElm = $('.search__input');
                this.resultsElm = $('.job-list');
                this.overlayElm = $('.overlay');

                var timer = null,
                    searchForm,
                    _this,
                    _val;

                this.inputElm.on('keyup change focusin', function (event) {
                    // Make the search active
                    _body.addClass('search-active');

                    // Only go further on letters or keys
                    if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 65 && event.keyCode <= 90)) {
                        _this = $(this);
                        _val = _this.val();

                        // Override targets
                        searchForm = _this.parents('.search-form');
                        fn.search.resultsElm = searchForm.find('.job-list');

                        if (_val.length >= 1) {
                            // Remove previous results
                            fn.search.resultsElm.empty();

                            // Show the loader
                            fn.search.loader.showLoader();
                            _this.parents('.search-form').addClass('active');

                            // Mark the header as active
                            _this.parents('.site-header').addClass('active');

                            // Show the overlay
                            if (_this.parents('.search-form--main-search').length >= 1) {
                                fn.search.overlayElm.addClass('active');
                            }

                            // Update the resultsElm status
                            fn.search.resultsElm.removeClass('job-list--inactive');

                            // Make sure the label doesnt layers over the text
                            searchForm.find('label.search__info-text').removeClass('inactive');

                            // If the timer has been set already => clear it
                            if (timer !== null) {
                                clearTimeout(timer);
                                timer = null;
                            }

                            // Set the interval to trigger the search in 2secs
                            timer = setTimeout(function () {
                                // Start the search
                                fn.search.startSearch(_this, 10, 0);
                            }, 1000);
                        } else {
                            // Hide the loader
                            fn.search.clearResults();
                        }
                    }
                });

                // Remove the results on overlay-click
                this.overlayElm.on('click', function (e) {
                    if ($(this).hasClass('active')) {
                        fn.search.clearResults();
                        fn.search.overlay.hideOverlay();
                        fn.search.headerSearch.close();
                    }
                });

                // Only allow the click-to-remove if the search is active
                _body.on('click', function (e) {
                    if (_body.hasClass('search-active')) {
                        fn.search.clearResults();
                    }
                });

                $('.search').on('click', function (e) {
                    e.stopPropagation();
                });

                var _parent;
                $('.search-trigger').on('click', function (e) {
                    e.preventDefault();

                    _parent = $(this).parent();
                    if (!_parent.hasClass('active')) {
                        fn.search.headerSearch.open();
                    } else {
                        fn.search.headerSearch.close();
                    }
                });
            }
        },


        /**
         * Unit links functionality
         */
        entry_level: {
            init: function () {
                var _this, links = $('.list--units a[data-id]');
                links.on('click', function (e) {
                    e.preventDefault();
                    _this = $(this);

                    // Change the links
                    links.removeClass('active');
                    _this.addClass('active');

                    // Change the units
                    $('.unit[data-id]').removeClass('active');
                    $('.unit[data-id="' + _this.attr('data-id') + '"]').addClass('active');
                });
            }
        },


        /**
         * Remember Link functionality
         */
        remember: {
            removeJob: function (_this) {
                var savedJobs = $.cookie('hse24SavedJobs'),
                    jobID = 0;

                // Check if the job exists and get the selected job id
                if (_this[0]) {
                    jobID = _this.data('job-id');
                }

                log('** REMOVE THE JOB: ' + jobID);

                // Make sure there are actually jobs to remove
                if (savedJobs !== undefined && jobID !== 0) {
                    // Get the jobs array
                    savedJobs = savedJobs.split(',');

                    for (var i = 0; i < savedJobs.length; i++) {
                        // Check for the given id
                        if (parseInt(savedJobs[i]) === parseInt(jobID)) {
                            // Found it => remove from array
                            savedJobs.splice(i, 1);
                        }
                    }

                    // Override jobs
                    log('Set cookie for ' + location.host);
                    $.cookie('hse24SavedJobs', savedJobs, {path: '/'});
                }

                // Remove the modifier class
                _this.removeClass('remember-link--remembered');

                var parentElm = _this.parent().parent();
                if (parentElm.hasClass('list-item')) {
                    parentElm.removeClass('is-remembered');
                }
            },

            addJob: function (_this) {
                var savedJobs = $.cookie('hse24SavedJobs'),
                    jobID = 0;

                // Check if the job exists and get the selected job id
                if (_this[0]) {
                    jobID = _this.data('job-id');
                }

                log('** ADD THE JOB: ' + jobID);

                if (savedJobs !== undefined && jobID !== 0) {
                    // There are already some jobs => Append the new one
                    log('Set cookie for ' + location.host);
                    $.cookie('hse24SavedJobs', savedJobs + ',' + jobID, {path: '/'}); // Add the new job (comma separated)
                } else if (savedJobs === undefined && jobID !== 0) {
                    // There are no jobs at the momemt => Insert the new one
                    log('Set cookie for ' + location.host);
                    $.cookie('hse24SavedJobs', jobID, {path: '/'});
                }

                // Add the modifier class
                _this.addClass('remember-link--remembered');

                var parentElm = _this.parent().parent();
                if (parentElm.hasClass('list-item')) {
                    parentElm.addClass('is-remembered');
                }
            },

            listener: function () {
                var _this;

                // Rebind
                this.targets = $('.remember-link');

                this.targets.unbind('click').on('click', function (e) {
                    e.preventDefault();
                    _this = $(this);

                    if (_this.hasClass('remember-link--remembered')) {
                        fn.remember.removeJob(_this);
                    } else {
                        fn.remember.addJob(_this);
                    }
                });
            },

            init: function () {
                this.targets = $('.remember-link');

                if (this.targets.length > 0) {
                    this.listener();
                }
            }
        },


        /**
         * JS for the jobs-overview-page
         */
        jobsOverview: {
            filter: {
                jobListOrder: null,

                // Start the actual filtering
                startFiltering: function () {
                    var targets = $('[data-filter-id]:checked'),
                        allItems = $('ul.jobs-overview__list li.list-item'),
                        classStr = '',
                        _this;

                    if (targets.length > 0) {
                        var checkedUnits = $('[data-filter-id^="hse-unit-"]:checked'),
                            checkedLocations = $('[data-filter-id^="hse-location-"]:checked'),
                            checkedLevels = $('[data-filter-id^="hse-level-"]:checked');

                        /**
                         * Checked Units
                         */
                        checkedUnits.each(function () {
                            // Save this item
                            _this = $(this);

                            // Add the current unit
                            classStr += '.' + _this.data('filter-id');

                            /**
                             * Checked Locations
                             */
                            checkedLocations.each(function () {
                                // Save this item
                                _this = $(this);

                                // Add the current location
                                classStr += '.' + _this.data('filter-id');
                            });

                            /**
                             * Checked Levels
                             */
                            checkedLevels.each(function () {
                                // Save this item
                                _this = $(this);

                                // Add the current level
                                classStr += '.' + _this.data('filter-id');
                            });

                            // Divide them
                            classStr += ', ';
                        });

                        /**
                         * Fallback if there are not units selected
                         */
                        if (checkedUnits.length === 0) {
                            /**
                             * Checked Locations
                             */
                            checkedLocations.each(function () {
                                // Save this item
                                _this = $(this);

                                classStr += '.' + _this.data('filter-id');
                            });

                            /**
                             * Checked Levels
                             */
                            checkedLevels.each(function () {
                                // Save this item
                                _this = $(this);

                                classStr += '.' + _this.data('filter-id');
                            });
                        }

                        // Make sure there is no uneeded char
                        if (classStr.substr(-2) === ', ') {
                            classStr = classStr.substr(0, (classStr.length - 2));
                        }

                        // Check if there are results
                        if ($(classStr).length > 0) {
                            // Hide all items
                            allItems.hide().addClass('hidden');

                            // Only show the targets
                            $(classStr).show().removeClass('hidden');
                        } else {
                            allItems.hide().addClass('hidden');
                            // console.error('No results found');
                        }

                    } else {
                        // No items selected => reset filtering
                        allItems.show().removeClass('hidden');
                    }

                    this.handleOddEven();
                    this.handleCount();
                    this.handleJobAlert(checkedUnits, checkedLocations, checkedLevels);
                },

                // Add the current filter settings to the job alert
                handleJobAlert: function (checkedUnits, checkedLocations, checkedLevels) {
                    // Set default values
                    var unitsText = '',
                        locationsText = '',
                        levelsText = '',
                        i;

                    /**
                     * Bereiche-Text
                     */
                    if (checkedUnits === undefined || checkedUnits.length < 2) {
                        unitsText = 'Alle';

                        if (checkedUnits !== undefined && checkedUnits.length > 0) {
                            // Override to default
                            unitsText = '';

                            for (i = 0; i < checkedUnits.length; i++) {
                                unitsText += $(checkedUnits[i]).next('label').text() + ', ';
                            }

                            // Remove ', ' from str
                            if (unitsText.substr(-2) === ', ') {
                                unitsText = unitsText.substr(0, (unitsText.length - 2));
                            }
                        }

                        // Add the text
                        $('.unit-value').text(unitsText)
                    } else {
                        // Override to default
                        unitsText = '';

                        // Get the first value
                        unitsText += $(checkedUnits[0]).next('label').text();

                        // Add additional text
                        unitsText += ' und ' + (checkedUnits.length - 1) + ' Weitere';

                        // Add the text
                        $('.unit-value').text(unitsText)
                    }


                    /**
                     * Standorte-Text
                     */
                    if (checkedLocations === undefined || checkedLocations.length < 2) {
                        locationsText = 'Alle';

                        if (checkedLocations !== undefined && checkedLocations.length > 0) {
                            // Override to default
                            locationsText = '';

                            for (i = 0; i < checkedLocations.length; i++) {
                                locationsText += $(checkedLocations[i]).next('label').text() + ', ';
                            }

                            // Remove ', ' from str
                            if (locationsText.substr(-2) === ', ') {
                                locationsText = locationsText.substr(0, (locationsText.length - 2));
                            }
                        }

                        // Add the text
                        $('.locations-value').text(locationsText)
                    } else {
                        // Override to default
                        locationsText = '';

                        // Get the first value
                        locationsText += $(checkedLocations[0]).next('label').text();

                        // Add additional text
                        locationsText += ' und ' + (checkedLocations.length - 1) + ' Weitere';

                        // Add the text
                        $('.locations-value').text(locationsText)
                    }


                    /**
                     * Levels-Text
                     */
                    if (checkedLevels === undefined || checkedLevels.length < 2) {
                        levelsText = 'Alle';

                        if (checkedLevels !== undefined && checkedLevels.length > 0) {
                            // Override to default
                            levelsText = '';

                            for (i = 0; i < checkedLevels.length; i++) {
                                levelsText += $(checkedLevels[i]).next('label').text() + ', ';
                            }

                            // Remove ', ' from str
                            if (levelsText.substr(-2) === ', ') {
                                levelsText = levelsText.substr(0, (levelsText.length - 2));
                            }
                        }

                        // Add the text
                        $('.entry-level-value').text(levelsText)
                    } else {
                        // Override to default
                        levelsText = '';

                        // Get the first value
                        levelsText += $(checkedLevels[0]).next('label').text();

                        // Add additional text
                        levelsText += ' und ' + (checkedLevels.length - 1) + ' Weitere';

                        // Add the text
                        $('.entry-level-value').text(levelsText)
                    }
                },

                // Gets called after each filtering to make sure the visible odd/even order is correct
                handleOddEven: function () {
                    $('.list-item:visible:even').addClass('odd').removeClass('even');
                    $('.list-item:visible:odd').addClass('even').removeClass('odd');
                },

                // Gets called after each filtering to make sure the visible results count is correct
                handleCount: function () {

                    if (_lang === 'en-US') {
                        if ($('.list-item:visible').length > 1) {
                            $('.jobs-overview__content__title-count').html(
                                'We found <span class="count">' + $('.list-item:visible').length + '</span> jobs for you.'
                            );
                        } else if ($('.list-item:visible').length < 1) {
                            $('.jobs-overview__content__title-count').html(
                                ''
                            );
                        } else {
                            $('.jobs-overview__content__title-count').html(
                                'We found <span class="count">a</span> job for you.'
                            );
                        }

                    } else {
                        if ($('.list-item:visible').length > 1) {
                            $('.jobs-overview__content__title-count').html(
                                'Wir haben <span class="count">' + $('.list-item:visible').length + '</span> Jobs für Dich gefunden.'
                            );
                        } else if ($('.list-item:visible').length < 1) {
                            $('.jobs-overview__content__title-count').html(
                                ''
                            );
                        } else {
                            $('.jobs-overview__content__title-count').html(
                                'Wir haben <span class="count">einen</span> Job für Dich gefunden.'
                            );
                        }
                    }
                },

                // Gets called just before the sorting starts, to make sure the order is saved
                saveJobListOrder: function () {
                    var jobsOverviewList = $(".job-list--jobs.jobs-overview__list"),
                        order = [],
                        i = 0;

                    // Walk through the list
                    jobsOverviewList.find('.list-item').each(function () {
                        order[i] = $(this).data('job-id');

                        i++;
                    });

                    this.jobListOrder = order;
                },

                // Rests the order of the list when the sorting has been used
                resetJobListOrder: function () {
                    var orderIDs = this.jobListOrder,
                        i = 0;

                    if (this.jobListOrder instanceof Array) {
                        orderIDs = this.jobListOrder.reverse();
                    }

                    for (i = 0; i < orderIDs.length; i++) {
                        $('.job-list--jobs .list-item[data-job-id="' + orderIDs[i] + '"]').prependTo(".job-list--jobs.jobs-overview__list");
                    }
                },

                // Close all open filters
                closeFilters: function () {
                    $('.jobs-overview__list__item').removeClass('active');
                },

                // Bind clicks and stuff
                binding: function () {
                    var _this,
                        oldListOrder = null,
                        jobsOverviewList = $(".job-list--jobs.jobs-overview__list");

                    // Get all remembered-items at the top
                    $('.job-list__legend__name').on('click', function (e) {
                        e.preventDefault();
                        _this = $(this);

                        // Clicked the "remember" button
                        if (_this.hasClass('job-list__legend__name--remember') && !jobsOverviewList.hasClass('ordered--remember')) {
                            // Save the current list ordner
                            fn.jobsOverview.filter.saveJobListOrder();

                            // The clicked elm is the remember-filter-button and it has not been filtered yet
                            jobsOverviewList.addClass('ordered--remember').orderChildren([
                                ".is-remembered",

                            ]);

                        } else if (_this.hasClass('job-list__legend__name--remember') && jobsOverviewList.hasClass('ordered--remember')) {
                            // List was filtered before => reset to default view
                            jobsOverviewList.removeClass('ordered--remember');

                            // Reset the job list order to the previous order
                            fn.jobsOverview.filter.resetJobListOrder()
                        }

                        fn.jobsOverview.filter.handleOddEven();

                        // Re-set the listener
                        fn.remember.listener();

                        // Toggle the active states
                        _this.parent('.jobs-overview__list__item').toggleClass('active');
                    });

                    // Filter the checkboxes
                    $('.jobs-overview__list__filter input[type="checkbox"]').on('click', function () {
                        fn.jobsOverview.filter.startFiltering();
                    });

                    // Close filter on Panic click
                    $('body').on('click', function () {
                        fn.jobsOverview.filter.closeFilters();
                    });

                    // Dont close the filters on actual filter clicks
                    $('.jobs-overview__content').on('click', function (e) {
                        e.stopPropagation();
                    });
                }
            },

            hashFilter: {
                addCheckboxStatus: function () {
                    var hash = location.hash;

                    if (hash.length > 1) {
                        var hashSplit = hash.split('='),
                            target;

                        // Check if there is actually a split
                        if (hashSplit.length > 1) {
                            // Switch the first part of the split
                            switch (hashSplit[0]) {
                                // Bereich gefiltert
                                case '#bereich':

                                    var unit = unit_translator[hashSplit[1]];
                                    console.log(unit);
                                    // Save the target elm
                                    target = $('[data-filter-id="hse-unit-' + unit + '"]');

                                    // Check if the target item exists
                                    if (target[0]) {
                                        // Check it
                                        target.prop('checked', true);

                                        // Start filtering
                                        fn.jobsOverview.filter.startFiltering();
                                    }
                                    break;

                                // Bereich gefiltert
                                case '#einstiegslevel':
                                    // Save the target elm
                                    target = $('[data-filter-id="hse-level-' + hashSplit[1] + '"]');

                                    // Check if the target item exists
                                    if (target[0]) {
                                        // Check it
                                        target.prop('checked', true);

                                        // Start filtering
                                        fn.jobsOverview.filter.startFiltering();
                                    }
                                    break;
                            }
                        }
                    }
                },

                init: function () {
                    // Add listener
                    _window.on('hashchange jobsLoaded', function () {
                        fn.jobsOverview.hashFilter.addCheckboxStatus();
                    });
                }
            },

            init: function () {
                if ($('.module.jobs-overview')[0]) {
                    fn.jobsOverview.filter.binding();
                    fn.jobsOverview.hashFilter.init();
                }
            }
        },


        /**
         * Handle the jobAlarm
         */
        jobAlarm: {
            submitButton: null,
            emailInput: null,
            phoneInput: null,
            dataPrivacyCheckbox: null,
            error: '',

            loader: {
                elm: $('.module.job-alarm'),

                show: function () {
                    this.elm.addClass('is-loading');
                },

                hide: function () {
                    this.elm.removeClass('is-loading');
                },
            },

            /**
             * Check if the form is valid
             * @returns {boolean}
             */
            isFormValid: function () {
                var emailIsValid = false,
                    phoneIsValid = false,
                    dataPrivacyChecked = false,
                    _status = false,
                    emailRe = /\S+@\S+/;


                // Check email
                if (this.emailInput.val().length > 0 && emailRe.test(this.emailInput.val())) {
                    emailIsValid = true;
                } else {
                    if (_lang === 'en-US') {
                        this.error = 'The given E-Mail Adress is invalid.'
                    } else {
                        this.error = 'Die angegebene E-Mail Adresse ist ungültig.'
                    }
                }

                // Check phone
                // if(this.phoneInput.val().length > 0) {
                // 	phoneIsValid = true;
                // } else {
                // 	this.error = 'Die eingegebene Handynummer ist ungültig.';
                // }

                // Check data privacy checkbox
                if (this.dataPrivacyCheckbox.prop('checked')) {
                    dataPrivacyChecked = true
                } else {
                    if (_lang === 'en-US') {
                        this.error = 'Please accept our privacy policy.'
                    } else {
                        this.error = 'Bitte Akzeptiere unsere Datenschutzbestimmungen.';
                    }
                }


                // Remove invalid-phone error when a valid email address is given
                if ((emailIsValid && !phoneIsValid) && dataPrivacyChecked) {
                    this.error = '';
                }

                // Remove invalid-email-error when a valid phone is given
                if ((!emailIsValid && phoneIsValid) && dataPrivacyChecked) {
                    this.error = '';
                }

                if (!phoneIsValid && !emailIsValid) {
                    if (_lang === 'en-US') {
                        this.error = "At least one mobile phone number or email address must be given."
                    } else {
                        this.error = "Es muss mindestens eine Handynummer oder E-Mail Adresse angegeben werden."
                    }
                }


                // form is valid, if data-privacy is checked and phone OR email is valid
                if ((emailIsValid || phoneIsValid) && dataPrivacyChecked) {
                    _status = true;
                }

                // Return the status
                return _status;
            },


            /**
             * Will be called if the form is valid
             */
            submitForm: function () {
                var emailValue = $('[name="email"]').val(), phoneValue = $('[name="phone"]').val();

                // Show the loader
                this.loader.show();

                // Send the api call
                api.sendRequest('POST', 'add_job_alert', {
                    email: emailValue,
                    phone: phoneValue
                }, 'fn.jobAlarm.showResponse()');
            },


            /**
             * Will be called after the ajax call is done
             * @param response
             * @param target
             */
            showResponse: function (response, target) {
                var responseText = '';

                if (!response.status) {
                    responseText = '<div class="error"><h3>Fehler</h3><p>' + response.msg + '</p></div>';
                    if (_lang === 'en-US') {
                        responseText = '<div class="error"><h3>Error</h3><p>' + response.msg + '</p></div>';

                    }
                } else if (response.status === true) {
                    if (_lang === 'en-US') {
                        responseText = '<div class="success"><h3>Thank you! </h3> <p> Your data has been saved. You will receive more information shortly via WhatsApp or by email.</p></div>';
                    } else {
                        responseText = '<div class="success"><h3>Vielen Dank!</h3><p>Deine Daten wurden gespeichert, in Kürze erhältst Du weitere Informationen per WhatsApp oder per E-Mail.</p></div>';
                    }
                }

                // Remove the content/form so the message will be there alone
                $('.job-alarm.module .inner.content').remove();

                // Show the loader
                this.loader.hide();
                $('.job-alarm.module .response-message').empty().append(responseText);

                // Scroll to the target
                $('body, html').animate({scrollTop: this.loader.elm.offset().top}, 500);
            },


            /**
             * Set bindings
             */
            binding: function () {
                var error_msg_elm = $('.input-wrapper--submit .error');
                this.submitButton.on('click', function (e) {
                    e.preventDefault();

                    // Make sure the error msg is hidden
                    error_msg_elm.text('').removeClass('error--has-msg');

                    if (fn.jobAlarm.isFormValid()) {
                        fn.jobAlarm.submitForm();
                    } else {
                        error_msg_elm.text(fn.jobAlarm.error).addClass('error--has-msg');
                    }

                    return false;
                });
            },

            init: function () {
                // Only initialize if the module exists on the current page
                if ($('.module.job-alarm')[0]) {
                    // Init vars
                    this.submitButton = $('.module.job-alarm .input-wrapper--submit .button--primary');
                    this.emailInput = $('.module.job-alarm input[name="email"]');
                    this.phoneInput = $('.module.job-alarm input[name="phone"]');
                    this.dataPrivacyCheckbox = $('.module.job-alarm input[name="data_privacy"]');

                    // Start functions
                    this.binding();
                }
            }
        },


        /**
         * Accordion functionality
         */
        accordion: {
            readyCount: 0,

            hashOpen: {
                listener: function () {
                    var hash = window.location.hash,
                        elm,
                        content,
                        navOffset = 0,
                        navElm;

                    // Check if a hash is given
                    if (hash.length > 1) {
                        elm = $(hash);

                        // Make sure the elements exists and it is a accordion
                        if (elm[0] && elm.hasClass('accordion')) {
                            // Hide the other ones
                            $('.accordion').addClass('inactive').find('.accordion__content').css('height', 0);

                            // Save the content elm
                            content = elm.find('.accordion__content');

                            // Open the current one
                            if (content[0]) {
                                content.css('height', content.data('height') + 'px');
                                elm.removeClass('inactive');

                                setTimeout(function () {
                                    // Todo: This needs adjustments
                                    navElm = $('.main-header__nav');
                                    if (navElm.hasClass('main-header__nav--visible')) {
                                        navOffset = navElm.height() * 2;
                                    }

                                    $('html, body').animate({scrollTop: (elm.offset().top - navOffset) + 'px'}, 100);
                                }, 1000)
                            }
                        }
                    }
                },

                init: function () {
                    var accordions = $('dl.accordion');

                    if (fn.accordion.readyCount === accordions.length) {
                        // Catch the current hash
                        this.listener();
                    }

                    // Start listener to catch requests on the site too
                    _window.on('hashchange', function (e) {
                        e.preventDefault();

                        fn.accordion.hashOpen.listener();
                    })
                }
            },

            init: function () {
                var _this,
                    _parent,
                    _content,
                    _index = 0;

                $('dl.accordion').each(function () {
                    _this = $(this);
                    _parent = _this.parent();
                    _content = _this.find('.accordion__content');

                    _content.attr('data-height', _content.height());
                    if (_index !== 0) {
                        _this.addClass('inactive');
                        _content.css('height', 0);
                    }

                    _index++;
                    fn.accordion.readyCount++;
                });

                $("dt.accordion__title").click(function () {
                    _this = $(this);
                    _parent = _this.parent();
                    _content = _parent.find('.accordion__content');

                    // $('dl.accordion').removeClass('inactive');

                    if (_parent.hasClass('inactive')) {
                        // Add the height
                        _content.css('height', _content.data('height') + 'px');
                        _parent.removeClass('inactive');
                    } else {
                        _content.css('height', 0);
                        _parent.addClass('inactive');
                    }
                });

                if( $('dl.accordion').length > 0 ) {
                    this.hashOpen.init();
                }
            }
        },


        /**
         * Navigation and header functions
         */
        header: {
            nav: null,
            navHeight: 100,

            agent: function () {
                var posY,
                    pos = 0,
                    siteHeaderPos,
                    siteHeaderElm,
                    triggerAmount = 50; // Defines how much pixels must been scrolled before showing the nav by scroll-up

                if (_body.hasClass('job-page')) {
                    siteHeaderElm = $('.site-header__content-box');

                    if (siteHeaderElm[0]) {
                        siteHeaderPos = siteHeaderElm.offset().top;
                    }
                }

                _window.on('scroll', function (e) {
                    posY = parseFloat(_window.scrollTop());

                    /**
                     * HANDLE header
                     */
                    // If the user scrolls up and the nav is hidden atm
                    if (posY < pos && fn.header.nav.hasClass('main-header__nav--inactive')) {
                        fn.header.nav.addClass('main-header__nav--visible');
                    } else if (fn.header.nav.hasClass('main-header__nav--visible')) {
                        fn.header.nav.removeClass('main-header__nav--visible');
                    }

                    // Override pos
                    pos = posY;

                    console.log('posY:');
                    console.log(posY);
                    console.log('pos:');
                    console.log(pos);
                    console.log('fn.header.navHeight:');
                    console.log(fn.header.navHeight);


                    // Set active states
                    if (posY > fn.header.navHeight) {
                        // Scrolled to invisible area
                        if (!fn.header.nav.hasClass('main-header__nav--inactive')) {
                            fn.header.nav.addClass('main-header__nav--inactive');
                        }
                    } else if (fn.header.nav.hasClass('main-header__nav--inactive') && posY <= 0) {
                        fn.header.nav.removeClass('main-header__nav--inactive');
                    }

                    // Add animation
                    if (posY > (fn.header.navHeight + 50)) {
                        // Scrolled to invisible area
                        if (!fn.header.nav.hasClass('main-header__nav--has-animations')) {
                            fn.header.nav.addClass('main-header__nav--has-animations');
                        }
                    } else if (fn.header.nav.hasClass('main-header__nav--has-animations') && posY <= 0) {
                        fn.header.nav.removeClass('main-header__nav--has-animations');
                    }


                    /**
                     * HANDLE SITE HEADER
                     */
                    // Only call on job pages
                    if (siteHeaderElm !== undefined && siteHeaderElm[0]) {
                        if (posY > siteHeaderPos) {
                            if (!siteHeaderElm.hasClass('site-header__content-box--keep-position')) {
                                siteHeaderElm.addClass('site-header__content-box--keep-position');
                            }
                        } else if (siteHeaderElm.hasClass('site-header__content-box--keep-position')) {
                            siteHeaderElm.removeClass('site-header__content-box--keep-position');
                        }
                    }
                });
            },

            init: function () {
                this.nav = $('.main-header__nav');
                this.navHeight = this.nav.height();

                this.agent();

                $('body').on('click', '.menu-toggler', function () {
                    $('.main-header__nav').toggleClass('open');
                    $('body').toggleClass('menu-open');
                });
            }
        },


        /**
         * JS for the jobs-single-page
         */
        single: {
            jobs: {
                binding: function () {

                }
            },

            units: {
                init: function () {
                    fn.jobsOverview.filter.handleOddEven();
                }
            },

            init: function () {
                this.jobs.binding();
                this.units.init();
            }
        },

        testimonials: {

            init: function () {
                $('.module.quote .owl-carousel').owlCarousel({
                    items: 1,
                    autoplay: true,
                    nav: true,
                    dots: false,
                    touchDrag: false,
                    draggable: false,
                    mouseDrag: false,
                    loop: true
                });
            }
        },

        backgroundVideo: {
            init: function () {
                $('.bg-video[data-autoplay]').each(function () {
                    var video = this;

                    $(video).find('source[data-src]').each(function () {
                        this.src = this.getAttribute('data-src');
                        this.removeAttribute('data-src');
                    });

                    video.load();

                    var playPromise = video.play();

                    if (playPromise !== undefined) {
                        playPromise.catch(function () {
                            // Autoplay wurde vom Browser verhindert.
                        });
                    }
                });
            }
        },


        /**
         * Initialize functions (on document ready)
         */
        init: function () {
            this.form.init();
            this.search.init();
            this.entry_level.init();
            this.remember.init();
            this.jobsOverview.init();
            this.jobAlarm.init();
            this.single.init();
            this.accordion.init();
            this.header.init();
            this.testimonials.init();
        },

        /**
         * Initialize functions (on window load)
         */
        loaded: function () {
            this.backgroundVideo.init();
        },

        tracking: {
            init: function () {

                function gtag_report_conversiongtag_report_conversion(url) {
                    var callback = function () {
                        if (typeof(url) != 'undefined') {
                            window.location = url;
                        }
                    };
                    gtag('event', 'conversion', {
                        'send_to': 'AW-10879824286/eRnmCK-2_a8DEJ7j88Mo',
                        'event_callback': callback
                    });
                    return false;
                }

                $('.applylink').on('click', function (e) {
                    e.preventDefault();
                    gtag_report_conversiongtag_report_conversion($(this).attr('href'));
                });
            }
        },

        cookiebanner: {
            init: function () {

                if ($('#gmap-frame')) {
                    // $('#gmap-frame').attr('src', $('#gmap-frame').data('src'));
                }
                if ($('#kununu-frame')) {
                    $('#kununu-frame img').each(function () {
                        // $(this).attr('src', $(this).data('src'));
                    });
                }
            },
        }
    };

_document.ready(function () {
    plugins.init();
    fn.init();
});

_window.on('load', function () {
    plugins.loaded();
    fn.loaded();
    ajaxHandler.init();
    fn.cookiebanner.init();
    fn.tracking.init()
});
